import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PrimaryButton from '../PrimaryButton';
import RadioButtons, { RadioOptions } from '../RadioButtons';
import ConnectorSelector from '../ConnectorSelector';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setConnector } from '../../guestSlice';
import { selectDesiredChargieId, setDesiredChargieId } from '../../appSlice';

const GuestConnector: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { connectors } = useLocation().state;
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const desiredChargieId = useAppSelector(selectDesiredChargieId);

    const options: RadioOptions[] = [
        {
            label: 'Guest Checkout',
            subText: 'No account required.',
            value: 'guestCheckout',
        },
        {
            label: 'Create an account',
            subText: 'Save payment details. Checkout faster in the future.',
            value: 'createAccount',
        },
    ];

    useEffect(() => {
        if (selectedOption) {
            dispatch(setConnector(selectedOption));
            if (desiredChargieId) {
                dispatch(
                    setDesiredChargieId({
                        chargieId: desiredChargieId.chargieId,
                        startType: desiredChargieId.startType,
                        connector: selectedOption,
                    })
                );
            }
        }
    }, [selectedOption]);

    const handleSubmit = () => {
        navigate('/guest/checkout', { state: { slide: true } });
    };

    const goBack = () => {
        navigate('/guest/pricing');
    };

    return (
        <div className="guest-pricing-content">
            <div className="pricing-details-main-content">
                <div className="pricing__current-price">
                    <p className="pricing__price-title">Select plug</p>
                </div>
                <ConnectorSelector
                    connectors={connectors}
                    onPress={setSelectedOption}
                    showFull={true}
                />
            </div>
            <div className="modal__button" id="guest_checkout_modal__button">
                <PrimaryButton
                    title={'Continue'}
                    onPress={handleSubmit}
                    disabled={!selectedOption}
                />
                <button
                    className="payment__back-button"
                    id="guest_checkout_back__button"
                    onClick={() => goBack()}
                >
                    Back
                </button>
            </div>
        </div>
    );
};

export default GuestConnector;
